<page-toolbar title="Failed Pipe Imports"></page-toolbar>

<page-content>
  <data-table (custom)="onCustom($event)"
                  (detail)="onDetail($event)"
                  [columns]="columns"
                  [dataProviderParams]="params"
                  [dataProvider]="pipeImportService"
                  [icon]="'receipt'"
                  [title]="'Failed Pipe imports'"
                  noDataMessage="Hooray no pipes failing"></data-table>
</page-content>
